export default __webpack_public_path__ + "static/media/xpress-shipping.643b2d3e.gif";